import { render, staticRenderFns } from "./personIconImage.vue?vue&type=template&id=41b94fb5&scoped=true&"
var script = {}
import style0 from "./personIconImage.vue?vue&type=style&index=0&id=41b94fb5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b94fb5",
  null
  
)

export default component.exports